import Column from "./Column/index";
import Columns from "./Columns/index";
import Search from "./Search/index";
import Navigation from "./Navigation/index";
import Copyright from "./Copyright/index";
import PoweredBy from "./PoweredBy/index";
import PressLogo from "./PressLogo/index";
import Socials from "./Socials/index";

export default {
  Column,
  Columns,
  Search,
  Navigation,
  Copyright,
  PoweredBy,
  PressLogo,
  Socials
};
